export const STATUS_COMMAND_ID = 'issue-field-status.ui.status-view.command-palette.issue-status';
